// extracted by mini-css-extract-plugin
export default {"wrapper":"didYouKnow_wrapper__woqRa","title":"didYouKnow_title__K3ONl","text":"didYouKnow_text__sxflF"};